export default __webpack_public_path__ + "static/media/graph.0c2c038d.png";